export { PriceTag } from './PriceTag';
export { OldPriceTag } from './OldPriceTag';
